import { graphql } from 'react-relay/legacy';
import serverVars from 'server-vars';
import commitMutation from 'relay-commit-mutation-promise';
import { executeCaptcha } from 'dibs-recaptcha/exports/recaptcha';
import { getAuthHash } from '../authHelpers.es';
import { getRegistrationTriggerValue } from '../registrationTrigger';

const mutation = graphql`
    mutation registrationMutation($input: UserRegistrationInput!) {
        userRegistration(input: $input) {
            emailToken
            user {
                serviceId
                userId: serviceId # for backwards compatibility with old versions
                createdDate
                isVerifiedTrade
                verifiedTradeStatus
                profile {
                    email
                    firstName
                    lastName
                    currency
                    measurementUnit
                }
                ...tradeApplicationHelpers_user
            }
            userToken
            userId
            isNewUser
        }
    }
`;

export async function registrationMutation(environment, args) {
    const { email, password, marketingOptIn, ga, enableEmailValidation } = args;
    // Requires auth hash to prevent bots hitting graphQL directly and making fake auths.
    const authHash = getAuthHash({ email });
    const { captchaToken } = await executeCaptcha({
        featureFlag: 'registerCaptcha',
        relayEnvironment: environment,
    });
    const cookieDomain = serverVars.get('cookieDomain'); // for setting response cookies
    const registrationTrigger = getRegistrationTriggerValue({ ga });

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                email,
                password,
                marketingOptIn,
                authHash,
                cookieDomain,
                captchaToken,
                registrationTrigger,
                enableEmailValidation,
            },
        },
    });
}
